import { render, staticRenderFns } from "./c-image.vue?vue&type=template&id=624835ad"
import script from "./c-image.vue?vue&type=script&lang=js"
export * from "./c-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports